var map = {
	"./animal.svg": 341,
	"./arrow.svg": 342,
	"./bicycle.svg": 343,
	"./boat.svg": 344,
	"./bus.svg": 345,
	"./car.svg": 346,
	"./crane.svg": 347,
	"./default.svg": 348,
	"./helicopter.svg": 349,
	"./motorcycle.svg": 350,
	"./offroad.svg": 351,
	"./person.svg": 352,
	"./pickup.svg": 353,
	"./plane.svg": 354,
	"./ship.svg": 355,
	"./tractor.svg": 356,
	"./train.svg": 357,
	"./tram.svg": 358,
	"./trolleybus.svg": 359,
	"./truck.svg": 360,
	"./van.svg": 361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 370;